import pictures from '../../assests/assestimport.js';
const {cp} = pictures;
const coverall=[
    {
        id:1,
        label:'100% Cotton Coverall',
        band:"Shareef Tex",
        subcategory:"Cotton & Poly Cotton",
        sublink:"Cotton&PolyCotton",
        description:`100% Ctton coverall without reflective tapes
        (120-240) GSM
        Sizes: SMALL - 5XL
        Petrol Blue / Navy Blue /Royal blue/ Khaki / Orange / Red / Grey / White
        Made Pakistan `,
        image:cp[0],
        alt:"100% Cotton Coverall",
        hscode:'',
    },
    {
        id:2,
        label:'Ploy Cotton Coverall',
        band:"Shareef Tex",
        description:`Ploy Cotton coverall available in Single, Double, Triple-stitched seams for extra durability.
        Radio loop for easy clipping of a radio
        Two-way zip for quick and easy access
        Durable, strong and long lasting brass
        zips
        Hook and loop cuffs for a secure fit
        Pen pocket
        Available with reflective tape
        P.Blue/ N.blue /khaki/ Royal blue/ Orange / Red / Grey / White`,
        image:cp[1],
        alt:"Ploy Cotton Coverall",
        hscode:'',
    },
    {
        id:3,
        label:'Ploy Cotton Coverall',
        band:"Shareef Tex",
        description:`Single, Double, Triple-stitched seams for
        extra durability
        Radio loop for easy clipping of a radio
        Two-way zip for quick and easy access
        Durable, strong and long lasting brass
        zips
        Hook and loop cuffs for a secure fit
        Pen pocket
        Available with reflective tape
        P.Blue/ N.blue /khaki/ Royal blue/ Orange / Red / Grey / White`,
        image:cp[2],
        alt:"Ploy Cotton Coverall with Single, Double, Triple-stitched seams for extra durability. Radio loop for easy clipping of a radio Two-way zip for quick and easy access Durable, strong and long lasting brass zips Hook and loop cuffs for a secure fit Pen pocket Available with reflective tape P.Blue/ N.blue /khaki/ Royal blue/ Orange / Red / Grey / White",
        hscode:'',
    },
    {
        id:4,
        label:'Reflective Tapes Cotton Coverall',
        band:"Shareef Tex",
        subcategory:"Fire Retardant",
        sublink:"FireRetardant",
        description:`100%  COTTON COVERALL WITH 6 REFLECTIVE TAPES
        (150-350) GSM and different composition available
        SMALL - 5XL
         Petrol Blue / Navy Blue /Royal blue/ Khaki / Orange / Red / Grey / White
        Made Pakistan `,
        image:cp[3],
        alt:"Cotton Coverall with Reflective Tapes light blue color",
        hscode:'',
    },
    {
        id:5,
        label:'Reflective Tapes Cotton Zipper Coverall',
        band:"Shareef Tex",
        description:`100%  COTTON COVERALL WITH 6 REFLECTIVE TAPES
        260 GSM
        SMALL - 5XL
         Petrol Blue / Navy Blue /Royal blue/ Khaki / Orange / Red / Grey / White
        Made Pakistan `,
        image:cp[4],
        alt:"Reflective Tapes Cotton Coverall with zipper and of color dark blue color",
        hscode:'',
    },
    {
        id:6,
        label:'Flame Resistant Reflective Tapes Coverall',
        band:"Shareef Tex",
        description:`Inherent flame-resistant qualities will
        not diminish with washing
        Protection against radiant, convective,
        and contact heat
        Flame-resistant industrial wash tape
        Double, Triple-stitched seams for extra
        durability
        Radio loop for easy clipping of a radio
        Two-way zip for quick and easy access
        Durable, strong, and long-lasting brass
        zips
        Hook and loop cuffs for a secure fit
        Two-tier knee pad pockets allow two
        positioning options
        Available with flame retardant
        reflective tape`,
        image:cp[8],
        alt:"Flame Resistant Reflective Tapes Coverall",
        hscode:'',
    },
    {
        id:7,
        label:'Bulldozer Nomex IIIA FR Suit',
        band:"Bulldozer",
        description:`BULLDOZER FIRE FIGHTING SUITBULLDOZER FIRE FIGHTING SUIT 
        Nomex® III A, Navy Blue / Yellow Nomex/FR Rayon with PTFE coating
        Protection against Flash Fire, Industrial Fire Fighting`,
        image:cp[6],
        alt:"Bulldozer Nomex IIIA FR Suit",
        hscode:'',
    },
    {
        id:8,
        label:'FR Turnout Gear Suit',
        band:"System5s",
        description:`FIRE PROXIMITY SUIT
        souter shell: Nomex®IIIA
        Moisture Barrier: PTFE Membrane
        Thermal Barrier: FR Non woven (Nomex® / Kevlar)
        Quilted to face Cloth
        Jacket and Trouser manufactured with inherent
        flame retardant threads
        FR Zipper + FR Velcro + HR Buckles + HR Buttons
        Nomex®IIIA Extra Additional Layer of outer shell
        fabric is provided at the knee portion as the best
        reinforcement to enhance the life of the garment
        during kneeling or any such operation
        Size: S to XXXL (The size of Jacket and Trouser
        confirming to EN 13688:2013 harmonized)
        Color: Navy Blue, Red & Yellow`,
        image:cp[7],
        alt:"System5s Fire Retardant turnout Gear Suit",
        hscode:'',
    },
    {
        id:9,
        label:'BDUSP2-2-BU',
        band:"Bulldozer",
        description:`BULLDOZER FIRE FIGHTING SUIT
        Fire Fighting Suit c/w Jacket & Trousers, NAVY BLUE, PYROVATEX, Model: BD USP2-2,  BULLDOZER, U.K`,
        image:cp[5],
        alt:"Bulldozer Fire Fighting Suit",
        hscode:'',
    },
    {
        id:10,
        label:'Desert Gold IFR Coverall',
        band:"Shareef Tex",
        description:`Breathable and ultra lightweight material to optimise body heat for middle eastern climates
        Oekotex 100 certified to ensure no harmful substances reach the user        
        Best-in-Class Safety Performance with just 18.2% overall burns (tested as per NFPA 2112 standard
        Available Colors: Royal Blue & Red
        Composition: Modacrylic 50%, P- Aramid 10%, Cotton 38%, Anti Static 2%
        Weight: 180 GSM
        Weave: Plain (1/1)
        `,
        image:cp[12],
        alt:"Desert Gold IFR Coverall",
        hscode:'',
    },
    {
        id:11,
        label:'Fire Retardant Coverall',
        band:"Shareef Tex",
        description:`100%  COTTON FR COVERALL
        260 GSM
        SMALL - 5XL
        Orange/ N.blue /khaki/ Royal blue/ Red`,
        image:cp[13],
        alt:"Fire Retardant Coverall",
        hscode:'',
    },
    {
        id:12,
        label:'AIRMAX Coverall',
        band:"Shareef Tex",
        description:`100% TWILL COTTON COVERALL
        195 GSM
        khaki/ grey / N.blue / P.blue / red / royal blue / yellow`,
        image:cp[14],
        alt:"AIRMAX Coverall",
        hscode:'',
    },
    {
        id:13,
        label:'AIRMAX Coverall',
        band:"Shareef Tex",
        description:`100%  COTTON COVERALL WITH 6 REFLECTIVE TAPES
        260 GSM
        SMALL - 5XL
         Petrol Blue / Navy Blue /Royal blue/ Khaki / Orange / Red / Grey / White
        Made Pakistan `,
        image:cp[15],
        alt:"AIRMAX Coverall",
        hscode:'',
    },
    {
        id:14,
        label:'Pants and Shirt',
        band:"Shareef Tex",
        description:`100%  COTTON PANT SHIRT
        260 GSM
        SMALL - 5XL
        P.Blue/ N.blue /khaki/ Royal blue`,
        image:cp[16],
        alt:"Pants and Shirt",
        hscode:'',
    },
    {
        id:15,
        label:'Fire Retardant Pant Shirt',
        band:"Shareef Tex",
        description:`100%  COTTON Fire Retardant PANT SHIRT
        260 GSM
        SMALL - 5XL
        Orange/ N.blue`,
        image:cp[17],
        alt:"Fire Retardant Pant Shirt",
        hscode:'',
    },
    
    {
        id:16,
        label:'PortWest Construction Reflective Tapes Coverall',
        band:"Shareef Tex",
        subcategory:"High Visibility Coverall",
        sublink:"HighVisibilityCoverall",
        description:`100% Cotton
        Micro Fabric
        Poly-cotton
        Available in different colors,
        compositions, and (120-240) GSM
        60-degree color fastness
        Single, Double, Triple-stitched seams
        for extra durability
        Pen pocket
        Available with reflective tape`,
        image:cp[9],
        alt:"PortWest Construction Reflective Tapes Coverall",
        hscode:'',
    },
    {
        id:17,
        label:'High Visibility Ploy-Cotton Shirt',
        band:"Shareef Tex",
        description:`60-degree color fastness
        Single, Double, Triple-stitched seams
        for extra durability
        Pen pocket
        Available with reflective tape`,
        image:cp[10],
        alt:"High Visibility Ploy-Cotton Shirt",
        hscode:'',
    },
    {
        id:18,
        label:'High Visibility Ploy-Cotton Pants',
        band:"Shareef Tex",
        description:`60-degree color fastness
        Single, Double, Triple-stitched seams
        for extra durability
        Pen pocket
        Available with reflective tape`,
        image:cp[11],
        alt:"High Visibility Ploy-Cotton Pants",
        hscode:'',
    },
    {
        id:19,
        label:'TWILL COTTON PANT SHIRT',
        band:"Shareef Tex",
        subcategory:"Medical Coverall",
        sublink:"MedicalCoverall",
        description:`100% TWILL COTTON PANT SHIRT
        195 GSM
        grey/khaki/n.blue/orange/p.blue/red/royal blue/ yellow`,
        image:cp[18],
        alt:"TWILL COTTON PANT SHIRT",
        hscode:'',
    },
    {
        id:20,
        label:'DUPONT TYVEK Classic Coverall',
        band:"Shareef Tex",
        description:`DUPONT TYVEK® COVERALL Style & Design:
        Disposable coveralls protect workers from dry particulates in asbestos and lead abatement, paint spraying, maintenance, and more.
        Comfortable, disposable Tyvek® coveralls feature an improved fit and elastic waist in the back for easy movement. 
        Deliver this excellent protection to workers today.
        3-Piece hood fits tightly, even when wearers move their head.
        Exterior stitched seams for a high level protection from the outside in.
        With a 3-Piece gusset and elastic waist, the Tyvek® garment ensures optimal fit with better freedom of movement.
        Zipper with self-adhesive double zip flap.
        Color: White, Sizes : M - 2XL `,
        image:cp[19],
        alt:"CLASSIC",
        hscode:'',
    },
    {
        id:21,
        label:'TYVEK 200',
        band:"Shareef Tex",
        description:`Tyvek® 200 Easysafe
        Hooded coverall with elastics
        Stitched (external), yellow
            100 per box, individually packed`,
        image:cp[20],
        alt:"TYVEK 200",
        hscode:'',
    },
    {
        id:22,
        label:'SP700CP',
        band:"SafetyPlusWorld",
        description:`SAFETYPLUS TYPE 5/6 DISPOSABLE Micro
        porous Coverall , 65gsm, Antistatic with Zipper flap cover and Adhesive tapes, Surged Seam with Hood, No Boots.`,
        image:cp[21],
        alt:"SP700CP",
        hscode:'',
    },
    {
        id:23,
        label:'Promax Chemical Suit',
        band:"Shareef Tex",
        description:`Promax PVC clothing
        Chemical & Flame resistant
        Attached hood
        Ultrasonically welded seems
        Disposable coverall`,
        image:cp[22],
        alt:"Promax Chemical Suit",
        hscode:'',
    },
    {
        id:24,
        label:'Promax Chemical Coverall',
        band:"Shareef Tex",
        description:`Promax PVC clothing
        Chemical & Flame resistant
        Attached hood
        Ultrasonically welded seems
        Disposable coverall`,
        image:cp[23],
        alt:"Promax Chemical Coverall",
        hscode:'',
    },
]
export default coverall;